import { Col, Row, Table } from "antd";
import { useTranslation } from "react-i18next";
import { IoDuplicateOutline } from "react-icons/io5";
import {
  MdCancel,
  MdCheckCircle,
  MdOpenInNew,
  MdOutlineDeleteOutline,
  MdTune,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Pagination from "shared/components/Pagination";
import { NAME_SPACES } from "shared/locales/constants";
import { COLORS } from "shared/style/colors";
import { SCREENS } from "utils/constants";

function List({ data, count, setValues, skip, duplicate, setFilter, orderBy }) {
  const navigate = useNavigate();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.INSURANCE_PLAN);
  const LIST = t("LIST", { returnObjects: true });

  const columns = [
    {
      title: LIST.NAME,
      dataIndex: "name",
      render: (item) => item || "-",
    },
    {
      title: LIST.DESCRIPTION,
      dataIndex: "description",
      render: (item) => item || "-",
    },
    {
      title: LIST.ALIAS,
      dataIndex: "alias",
      render: (item) => item || "-",
    },
    {
      title: LIST.ACTIVE,
      dataIndex: "active",
      render: (item) =>
        item ? (
          <MdCheckCircle size={24} color={COLORS.C_SUCCESS} />
        ) : (
          <MdCancel size={24} color={COLORS.C_DANGER} />
        ),
    },
    {
      title: LIST.INTERNAL,
      dataIndex: "internal",
      render: (item) =>
        item ? (
          <MdCheckCircle size={24} color={COLORS.C_SUCCESS} />
        ) : (
          <MdCancel size={24} color={COLORS.C_DANGER} />
        ),
    },
    {
      title: LIST.MADELIN,
      dataIndex: "fields",
      render: (item) =>
        item?.madelin ? (
          <MdCheckCircle size={24} color={COLORS.C_SUCCESS} />
        ) : (
          <MdCancel size={24} color={COLORS.C_DANGER} />
        ),
    },
    {
      title: LIST.ACTIONS,
      dataIndex: "id",
      align: "right",
      render: (id) => (
        <Row gutter={8} justify="end" align="center" wrap={false}>
          <Col
            onClick={() => {
              duplicate({
                variables: {
                  where: { id },
                },
              });
            }}
          >
            <IoDuplicateOutline size={24} />
          </Col>
          <Col
            onClick={() =>
              navigate(
                `${SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.CONFIGURE.path}/${id}`,
              )
            }
          >
            <MdTune size={24} color={COLORS.C_PRIMARY} />
          </Col>
          <Col
            onClick={() =>
              navigate(
                `${SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.DETAIL.path}/${id}`,
              )
            }
          >
            <MdOpenInNew size={24} color={COLORS.C_PRIMARY} />
          </Col>
          <Col
            onClick={() =>
              navigate(
                `${SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.DELETE.path}/${id}`,
              )
            }
          >
            <MdOutlineDeleteOutline size={24} color={COLORS.C_DANGER} />
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        className="table__wrapper"
        columns={columns}
        rowKey={"id"}
        pagination={false}
        scroll={{ x: true }}
      />
      <Pagination count={count} setValues={setValues} skip={skip} />
    </>
  );
}

export default List;
